import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { ApiService } from '../../../../shared/services/api-service/api-service';
import { generateQuery } from '../../../../store/effects/projections/student-groupings';
import { IFocus } from '../../academic-list-v2/academic-list-data/academic-data.service';

@Injectable()
export class PostsecondaryDataService {
  private fociCache$: Observable<any> = null;

  constructor(public apiService: ApiService) {}

  getPostsecondaryFocusData$(
    schoolId: string,
    focusKey?: string,
  ): Observable<{ data: { PostsecondaryFocus: IFocus[] } }> {
    const payload = this.getPostsecondaryFocusQuery(schoolId, focusKey);
    if (!focusKey) {
      if (!this.fociCache$) this.fociCache$ = this.apiService.getStudentsGraphQL(payload).pipe(shareReplay(1));
      return this.fociCache$;
    } else {
      return this.apiService.getStudentsGraphQL(payload);
    }
  }

  getPostsecondaryGroupingData$(payload: {
    schoolId: string;
    filterKeys: string[];
    groupingKey: string;
    columns: string[];
  }) {
    // only want active students, so we append this filter behind the scenes
    payload.filterKeys.push('ACTIVE_ONLY');

    const query = generateQuery({ payload });
    return this.apiService.getStudentsGraphQL({ query, fetchPolicy: 'no-cache' });
  }

  getPostsecondaryFocusQuery(schoolId: string, focusKey?: string) {
    const payload = focusKey ? `schoolId:"${schoolId}", focusKey:"${focusKey}"` : `schoolId:"${schoolId}"`;

    const query = `{
      PostsecondaryFocus(${payload}) {
        graphQlKey
        label
        isDefault
        category
        categoryOrder
        fociOrder
        filters {
          label
          filterOptions {
            graphQlKey
            label
            isDefault
          }
        }
        groupings {
          graphQlKey
          label
          requiresWildcard
          groupingSubgroups {
            label
            headerTooltip {
              ...on SimpleTooltip {
                simpleContent
              }
              ...on TableTooltip {
                tableContent {
                  headers
                  rowData
                }
              }
            }
          }
          columns {
            graphQlKey
            label
            requiresWildcard
            columnDataFormat
            cellConfig
            cellTooltip
            headerTooltip {
              ...on SimpleTooltip {
                simpleContent
              }
              ...on TableTooltip {
                tableContent {
                  headers
                  rowData
                }
              }
            }
          }
        }

      }
    }`;
    return { query, fetchPolicy: 'no-cache' };
  }

  clearFociCache(): void {
    this.fociCache$ = null;
  }
}
